export default __webpack_public_path__ + "static/media/Pilz-Button-Mitnehmen.eaa85c52.png";